import tradeMixin from './../../mixin/tradeMixin';
export const formFields = (ctx) => {
  return [
    /*{
      prop: 'companyCode',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: ctx.changeCompanyHandler,
      disabled: !ctx.isCreate,
      // disabled:
      //   ['create', 'edit'].includes(ctx.$route.query?.status) && ctx.$route.query?.id
      //     ? false
      //     : ctx.isCreate,
    },*/

    {
      prop: 'enterpriseName',
      name: '公司名称',
      type: 'select',
      options: ctx.newCompanyList,
      value: 'dataCode',
      label: 'dataName',
      changeMethod: ctx.newChangeCompanyHandler,
      disabled: !ctx.isCreate,
    },

    // {
    //   name: '申报日期',
    //   prop: 'reportedDate',
    //   type: 'date',
    //   changeMethod: 'changeReportedDateHandler',
    //   disabled: !ctx.isCreate,
    // },

    {
      name: '录入人',
      prop: 'reportedBy',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changePersonnelMethod,
      currentValue: ctx.baseFormData?.reportedBy,
      disabled: !ctx.isCreate,
      // disabled: true,
    },

    {
      name: '年月',
      prop: 'dataMonth',
      type: 'month',
      format: 'yyyy-MM',
      changeMethod: 'changeDataMonthHandler',
      disabled: !ctx.isCreate,
    },

    // {
    //   name: '地址',
    //   prop: 'address',
    //   // disabled: true,
    //   type: 'input',
    // },

    {
      name: '批次号',
      prop: 'importBatchNo',
      // disabled: true,
      type: 'input',
      disabled: !ctx.isCreate,
    },

    {
      name: '业务类型',
      prop: 'businessType',
      type: 'input',
      disabled: true,
    },

    {
      name: '单据状态',
      prop: 'status',
      type: 'input',
      disabled: true,
    },

    // {
    //   name: '编制人员',
    //   prop: 'weaveName',
    //   type: 'searchTableSpec',
    //   searchType: 'personnel',
    //   isMultiple: true,
    //   changeMethod: ctx.changeWeaveMethod,
    //   currentValue: ctx.baseFormData?.weaveName,
    //   disabled: !ctx.isCreate,
    // },
    // {
    //   name: '创建日期',
    //   prop: 'settlementCreateDate',
    //   type: 'date',
    //   disabled: true,
    // },

    {
      name: '备注',
      prop: 'remark',
      type: 'textarea',
      maxlength: 600,
      span: 24,
      disabled: !ctx.isCreate,
    },
  ];
};

export const formRules = {
  settlementCompanyNo: [{ required: true, message: '公司名称必填', trigger: 'change' }],
  settlementDepartmentNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  customerName: [{ required: true, message: '必填字段', trigger: 'change' }],
  originalTotalAmount: [{ required: true, message: '必填字段', trigger: 'change' }],
  domesticTotalAmount: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementDate: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementType: [{ required: true, message: '必填字段', trigger: 'change' }],
  currencyCode: [{ required: true, message: '必填字段', trigger: 'change' }],
  // exchangeDate: [{ required: true, message: '必填字段', trigger: 'change' }],
  salesmanName: [{ required: true, message: '必填字段', trigger: 'change' }],
  weaveName: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementBusinessType: [{ required: true, message: '必填字段', trigger: 'change' }],
  receivableAccountPeriod: [{ required: true, message: '必填字段', trigger: 'change' }],
  contractNo: [{ required: true, message: '必填字段', trigger: 'change' }],
  exchangeRate: [{ required: true, message: '必填字段', trigger: 'blur' }],
};

export const editFormRules = {
  settlementStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementIssueStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  settlementCreateDate: [{ required: true, message: '必填字段', trigger: 'change' }],

  // settlementIssueStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // receiveStatus: [{ required: true, message: '必填字段', trigger: 'change' }],
  // invoiceAmount: [{ required: true, message: '必填字段', trigger: 'blur' }],
  // collectedAmount: [{ required: true, message: '必填字段', trigger: 'blur' }],
};
import { formatDate } from '@/utils';
// 暴露出去
export default {
  mixins: [tradeMixin],
  data() {
    return {
      formRules,
      baseFormData: {
        settlementCompanyNo: '',
        settlementCompanyName: '',
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        customerName: '',
        customerNo: '',
        receivableSettlementNo: '',
        settlementDate: '',
        projectInitiationNo: '',
        contractNo: '',
        originalTotalAmountWithoutTax: '',
        originalTotalTaxAmount: '',
        domesticTotalAmountWithoutTax: '',
        domesticTotalTaxAmount: '',
        domesticTotalAmount: '',
        settlementType: '',
        currencyCode: '',
        currencyName: '',
        exchangeDate: formatDate(new Date()),
        exchangeRate: '',
        settlementStatus: '',
        settlementIssueStatus: '02',
        invoiceAmount: '',
        collectedAmount: '',
        salesmanNo: '',
        salesmanName: '',
        weaveNo: '',
        weaveName: '',
        settlementCreateDate: formatDate(new Date()),
        originalTotalAmount: '',
        settlementBusinessType: '01',
        receivableAccountPeriod: '',
        receiveStatus: '',
        printFlag: '',
        remark: '',
        signetType: '',
        reportedDate: '',
        dataMonth: '',
        reportedBy: '',
        companyCode: '',
      },
      productList: [],
      isCreate: false,
    };
  },
  watch: {
    'baseFormData.settlementDate': {
      deep: true,
      handler: function (newV) {
        console.log('watch中：', newV);
        this.baseFormData.receivableAccountPeriod =
          newV || this.baseFormData.receivableAccountPeriod;
      },
    },
  },
  computed: {
    formColumn() {
      return formFields(this);
    },
    baseFormRules() {
      if (this.isCreate) {
        return formRules;
      } else {
        return { ...formRules, ...editFormRules };
      }
    },
  },
  methods: {
    // 切换结算类型
    settlementTypeChange() {
      console.log('切换结算类型', this.baseFormData);
      this.initSignetType();
    },
    // 切换公司
    newChangeCompanyHandler(val) {
      console.log(val, '切换公司js');
      const item = this.newCompanyList.find((item) => item.dataCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        enterpriseName: item.dataName,
        companyCode: val,
        companyName: item.dataName,
      };
    },
    // 切换公司
    changeCompanyHandler(val) {
      console.log(val, '切换公司');
      const item = this.companyList.find((item) => item.personCompanyCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        departmentCode: '',
        departmentName: '',
        companyCode: val,
        companyName: item.personCompanyName,
      };
      // 获取部门数据
      this._getDepartmentByCompanyCodeApi(val);
    },
    // 切换部门
    changeDepartmentHandler(val) {
      console.log(val, '切换部门');
      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: val,
        settlementDepartmentName: item.personDepartmentName,
      };
    },
    // 修改客户
    changeCustomsMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        customerName: rowData?.partnerZhName,
        customerNo: rowData?.partnerCode,
      };
    },
    // 修改合同
    changeContractMethod(val) {
      const rowData = val[0];
      console.log(rowData, 'rowData');
      this.baseFormData = {
        ...this.baseFormData,
        contractNo: rowData?.contractNo,
        customerName: rowData?.customerName,
        customerNo: rowData?.customerNo,
        projectInitiationNo: rowData?.projectInitiationNo,
        projectName: rowData?.projectName,
        exchangeRate: rowData?.contractCurrencyExchangeRate
          ? rowData?.contractCurrencyExchangeRate + ''
          : '1',
        currencyCode: rowData?.contractCurrency,
        currencyName: rowData?.contractCurrencyName,
      };
      if (rowData.orderDetailList && rowData.orderDetailList.length) {
        this.productList = [];
        rowData.orderDetailList.map((item) => {
          if (item.contractMatterName && item.contractMatter) {
            this.productList.push({
              label: item.contractMatterName,
              value: item.contractMatter,
              contractDetailId: item.id,
              taxRate: item.taxRate,
              productModel: item.norms,
            });
          }
        });
      }
      this.settleAccountsRowList = [];
      this.$refs.linesRef.removeRowHandler();
      this.settleAccountsDetailMap = new Map();
      this.$refs?.lineDetails?.removeRowHandler();
      this.currentSettleAccountDetailList = [];
      this.currentSettleAccountRowData = null;
      this.currentDetailData = {};
      this.baseFormData = {
        ...this.baseFormData,
        originalTotalAmount: '0',
        originalTotalAmountWithoutTax: '0',
        originalTotalTaxAmount: '0',
        domesticTotalAmount: '0',
        domesticTotalAmountWithoutTax: '0',
        domesticTotalTaxAmount: '0',
      };
    },
    // 修改业务员
    changePersonnelMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        // salesmanNo: rowData?.personNo,
        reportedBy: rowData?.personName,
      };
    },
    // 修改编制人员
    changeWeaveMethod(val) {
      const rowData = val[0];
      this.baseFormData = {
        ...this.baseFormData,
        weaveNo: rowData?.personNo,
        weaveName: rowData?.personName,
      };
    },
    // 切换货币
    changeCurrencyHandler({ val }) {
      this.baseFormData = {
        ...this.baseFormData,
        currencyCode: val?.currencyCode,
        currencyName: val?.currencyName,
      };
      this.$emit('changeCurrencyHandler', val);
    },

    changeSettlementDateHandler(val) {
      console.log(val, '日期');

      this.$emit('changeSettlementDateHandler', val);
    },

    // 申报日期
    changeReportedDateHandler(val) {
      console.log(val, '日期');
      this.$emit('changeReportedDateHandler', val);
    },

    // 年月
    changeDataMonthHandler(val) {
      console.log(val, '日期');
      this.$emit('changeDataMonthHandler', val);
    },

    initSignetType() {
      if (
        this.baseFormData.settlementType == '1' &&
        this.baseFormData.settlementBusinessType == '01'
      ) {
        this.baseFormData.signetType = '1';
      } else {
        this.baseFormData.signetType = '';
      }
    },
  },
  mounted() {
    this.isCreate = ['create', 'edit'].includes(this.$route.query?.status);
    this.initSignetType();
    // console.log(this.dictListMap?.settlementIssueStatus, '单据状态');
  },
};
